<template lang="pug">
v-app
  SnackbarComponent(ref="snackbar")
  ModalRegulamentos(ref="modalRegulamentos")
  template(v-if="loading")
    LoadingResources
  template(v-else)
    NavBar(
      v-if="$route.meta.showSystemBars"
      :user="user"
      :loading="loadingResources"
      :dark-mode="darkMode"
      @toggleDrawer="toggleDrawer = !toggleDrawer"
      @logout="logout"
      @toggleDarkMode="toggleDarkMode($event)"
      @goToAccountManagement="goToAccountManagement"
    )
    ToolBar(
      v-if="$route.meta.showSystemBars"
      v-model="toggleDrawer"
      :nav-items="menuList"
      :loading="functionsLoaded"
      :user="user"
      @logout="logout"
      @goToAccountManagement="goToAccountManagement"
    )
    v-main
      v-fade-transition(mode="out-in")
        router-view(:key="$route.name")
      ButtonScrollToTop
</template>

<script>
import lodash from "lodash";
import ToolBar from "@/components/toolbar/ToolBar.vue";
import NavBar from "@/components/navbar/NavBar.vue";
import SnackbarComponent from "@/components/util/SnackbarComponent.vue";
import ButtonScrollToTop from "@/components/button/ButtonScrollToTop.vue";
import LoadingResources from "@/components/util/LoadingResources.vue";
import ModalRegulamentos from "@/components/modal/ModalRegulamentos.vue";
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";
import {
  PAGE_TITLE,
  FAVICON_LINK,
  ENABLE_DARK_MODE,
  DEBUG,
  VUE_APP_ENABLE_REGULAMENTOS,
} from "@/env.js";
export default {
  name: "App",
  components: {
    NavBar,
    ToolBar,
    SnackbarComponent,
    ButtonScrollToTop,
    LoadingResources,
    ModalRegulamentos,
  },
  data() {
    return {
      toggleDrawer: false,
      menuList: [],
      loading: true,
      showModalRegulamentos: false,
    };
  },
  computed: {
    ...mapFields("auth", ["user", "loadingResources"]),
    ...mapGetters("auth", ["getVersaoAceiteTermos"]),
    ...mapFields("regulamentos", ["versaoAtualRegulamento"]),
    ...mapFields("theme", ["defaultTheme"]),
    ...mapFields("functions", ["menu", "functionsLoaded"]),
    ...mapFields("common", ["darkMode", "enableDarkMode"]),
  },
  watch: {
    menu: {
      handler() {
        this.menuList = lodash.cloneDeep(this.menu);
      },
    },
    loadingResources: {
      handler() {
        this.loading = this.loadingResources;
        this.showModalTermos();
      },
    },
    defaultTheme: {
      handler() {
        this.$store.dispatch("theme/setInitialTheme", {
          theme: this.defaultTheme,
          vuetify: this.$vuetify,
        });
      },
    },
  },
  beforeCreate() {
    let remoteAppVersion = this.$store.getters.appVersion;
    let localAppVersion = window.localStorage.getItem(
      "data-sec-portal.appVersion"
    );
    if (remoteAppVersion !== localAppVersion) {
      this.$store.dispatch("auth/resetState");
      this.$store.dispatch("assets/resetState");
      this.$store.dispatch("theme/resetState");
      this.$store.dispatch("common/resetState");
      window.localStorage.setItem(
        "data-sec-portal.appVersion",
        remoteAppVersion
      );
    }
  },
  created() {
    this.showModalRegulamentos =
      process.env.NODE_ENV === "production"
        ? VUE_APP_ENABLE_REGULAMENTOS === "true"
        : process.env.VUE_APP_ENABLE_REGULAMENTOS === "true";

    if (DEBUG === "true" || process.env.NODE_ENV === "development") {
      console.log("Vuetify", this.$vuetify);

      console.log(
        "xl",
        this.$vuetify.breakpoint.xl,
        "lg",
        this.$vuetify.breakpoint.lg,
        "md",
        this.$vuetify.breakpoint.md,
        "sm",
        this.$vuetify.breakpoint.sm,
        "xs",
        this.$vuetify.breakpoint.xs,
        "xsOnly",
        this.$vuetify.breakpoint.xsOnly,
        "smOnly",
        this.$vuetify.breakpoint.smOnly,
        "mdOnly",
        this.$vuetify.breakpoint.mdOnly,
        "lgOnly",
        this.$vuetify.breakpoint.lgOnly,
        "xlOnly",
        this.$vuetify.breakpoint.xlOnly
      );
      console.log("Width", this.$vuetify.breakpoint.width);
      console.log("Threshold max width", this.$vuetify.breakpoint.thresholds);
    }

    document.title =
      process.env.NODE_ENV === "production" && PAGE_TITLE !== ""
        ? PAGE_TITLE
        : "Extreme Data Portal";
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    link.href =
      process.env.NODE_ENV === "production" && FAVICON_LINK !== ""
        ? FAVICON_LINK
        : "/favicon.ico";

    this.enableDarkMode =
      process.env.NODE_ENV === "production"
        ? ENABLE_DARK_MODE === "true"
        : process.env.VUE_APP_ENABLE_DARK_MODE === "true";
  },
  async mounted() {
    this.menuList = lodash.cloneDeep(this.menu);
    this.$root.snackbar = this.$refs.snackbar;
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
    },
    goToAccountManagement() {
      window.open(this.$store.getters["auth/getAccountManagementUrl"]);
    },
    toggleDarkMode(event) {
      this.darkMode = event;
      this.$vuetify.theme.dark = event;
    },
    showModalTermos() {
      if (!this.showModalRegulamentos) return;

      if (
        !this.loading &&
        this.getVersaoAceiteTermos !== this.versaoAtualRegulamento
      ) {
        this.$refs.modalRegulamentos.openModal();
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.app-bar
  background-color: red
</style>
